import React from 'react';
import '../styles/howTo.css'

function HowTo(props) {
  return (
		<div id='how-to-container'>
			<p id='how-to-p'>

				Search movie and show titles for their streaming platforms they're
				found on and more!
			</p>
		</div>
	);
}

export default HowTo;
